exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".farms-list-component[data-v-47b5c513] {\n  width: 100%;\n}\n.farms-list-component .header .title[data-v-47b5c513] {\n  color: #0B486B;\n  font-size: 32px;\n  font-weight: bold;\n  margin-bottom: 20px;\n}", ""]);

// exports
